<template>
	<vx-card >
		<p class="mb-2"><strong>Email</strong></p>
		<vs-input @keyup.enter="submit" class="w-full mb-8" v-model="email" />
		<vs-button color="primary" class="w-full py-4 rounded-lg" @click.prevent="submit" id="button-nih">
			<strong class="text-white">Lanjutkan</strong>
		</vs-button>
	</vx-card>
</template>
<script>
export default {
  data: () => ({
    email: null
  }),
  methods: {
    submit () {

      if (this.email === null) {
        this.$vs.notify({
          title: 'Harap masukan email anda',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }
				
      this.$emit('submit', this.email)
    }
  }
}
</script>